import { CommCenter } from "./CommCenter.js";
import { validateTidalLicense } from "../../../base/index.js";
validateTidalLicense();
export {
  CommCenter
};
//# sourceMappingURL=index.js.map
